<template>
  <section id="application-form" :class="{'with-box-shadow' : withBoxShadow}">
    <div class="nav-box" v-if="!hideNavBox">
      <application-nav
        ref="applicationNav"
        :application-config="applicationConfig"
        :application-data="applicationData"
        v-model="currentActiveGroupIndex"
        :group-status="groupStatus"
        :editable="Boolean(editable)"
      ></application-nav>
    </div>
    <div class="group-content">
      <application-group
        v-for="(group, index) in applicationConfig"
        :key="index"
        v-show="applicationConfig && applicationConfig.length > 0 && currentActiveGroupIndex === index"
        :application-config="applicationConfig"
        :config-group="group"
        :is-last-group="index === filterApplicationConfig.length - 1"
        :group-index="index"
        :form-ensured="formEnsured"
        :application-data="applicationData"
        :pcd-data="pcdData"
        :field-disbaled="!Boolean(editable)"
        :submitting="submitting"
        :need-ensure="needEnsure"
        :form-submitted="formSubmitted"
        :application-status="applicantApplicationOriginData.application_status"
        :is-reupload="isReupload"
        @fieldValueChanged="fieldValueChanged"
        @saveGroup="saveGroup"
        @updateGroupStatus="updateGroupStatus"
        @changeFormEnsured="changeFormEnsured"
        @autoSave="autoSave"
      ></application-group>
    </div>
  </section>
</template>

<script>
import extend from 'extend';
import _ from 'lodash';
import { Loading } from 'element-ui';

import utils from '../../../libs/utils';

import applicantConstants from '../../../constants/applicant-constants';

import applicationNav from './application-nav';
import applicationGroup from './application-group';

import pcdService from '../../../services/pcd-service';
import applicationFormService from '../../../services/application-form-service';
import ocrService from '../../../libs/ocr.js';

export default {
  name: 'application-form',
  components: {
    applicationNav,
    applicationGroup,
  },
  props: {
    // 后端返回的申请表链接
    backendApplicationUrl: {
      type: String,
      required: true,
      default: '',
    },

    // 申请人编号
    applicantId: {
      type: Number,
      required: true,
      default: 0,
    },

    // 是否需要确认
    needEnsure: {
      type: Boolean,
      default: true,
    },

    // 是否可以编辑
    editable: {
      type: Boolean,
      default: true,
    },

    // 是否有box-shadow样式
    withBoxShadow: {
      type: Boolean,
      default: true,
    },

    // 是否是重新上传页面
    isReupload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentActiveGroupIndex: 0, // 当前激活的组index
      applicationConfig: [], // 申请表配置对象
      applicationData: {}, // 申请表数据对象，用户填的都在里面了
      pcdData: {
        pcds: {}, // 省市区原始数据
        tranformedPcds: [], // 省市区转化过后的数据
      },
      formSubmitted: false, // 提交了表单
      formEnsured: false, // 用户是否确认(在最后一组里面)
      submitting: false, // 提交中
      groupStatus: {}, // 表单组的状态
      autoSaveIntervalTimer: null, // 自动保存计时器
      applicantApplicationOriginData: {}, // 申请人的申请表原始数据，指的是从后端加载过来的数据
      loadingInstance: null, // 加载中对象
    };
  },
  methods: {
    showField: applicationFormService.showField,
    // 获取省市区数据
    getPcd() {
      pcdService
        .getPcd()
        .then((pcds) => {
          const result = extend(true, {}, pcds);

          // 增加海外信息
          if (result['86']) {
            result['86']['990000'] = '海外';
            result['990000'] = {
              990001: '海外',
            };
          }
          this.pcdData.pcds = result;
          this.pcdData.tranformedPcds = applicationFormService.tranformPcd(
            result,
          );
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    // 用户确认
    changeFormEnsured(ensure) {
      this.formEnsured = ensure;
    },

    // 设置组状态
    setGroupStatus(applicationData, applicationConfig) {
      const result = {};
      applicationConfig.forEach((group) => {
        if (typeof applicationData[group.name] !== 'undefined') {
          // 我也不清楚到底有多少个值可以表示完成，反正这几个先加上
          result[group.name] =
            applicationData[group.name] === true ||
            applicationData[group.name] === 1 ||
            applicationData[group.name] === '1'
              ? applicantConstants.APPLICATION_GROUP_STATUS.valid
              : applicantConstants.APPLICATION_GROUP_STATUS.invalid;
        } else {
          result[group.name] =
            applicantConstants.APPLICATION_GROUP_STATUS.unknown;
        }
      });
      this.$emit('updatedApplicationGroupStatus', result);
      return result;
    },

    // 加载申请表的配置对象
    getApplicationConfig(backendApplicationUrl) {
      applicationFormService
        .getApplicationConfig(backendApplicationUrl)
        .then((data) => {
          this.applicationConfig = data;
          applicationFormService
            .getApplicationData(this.applicantId)
            .then((applicationData) => {
              this.applicantApplicationOriginData = applicationData;
              if (applicationData.content) {
                this.applicationData = JSON.parse(applicationData.content);
                console.log(this.applicationData);
              } else {
                this.applicationData = applicationFormService.setDefaultValueByApplicationConfig(
                  this.applicationConfig,
                );
                // 设置ocr数据
                this.applicationData = ocrService.fromOcr(
                  this.applicationData,
                  this.applicationConfig,
                  applicationData.id_card || {},
                  applicationData.passport || {},
                  applicationData.visa_type_id || '',
                  applicationData.depart_date || '',
                );
              }

              this.groupStatus = this.setGroupStatus(
                this.applicationData,
                this.applicationConfig,
              );

              // // 当申请表状态处于待填写时，启动自动保存
              // if (Number(this.applicantApplicationOriginData.application_status) === 1) {
              //   this.startAutoSaveInterval();
              // }

              if (this.loadingInstance) {
                this.$nextTick(() => {
                  this.loadingInstance.close();
                });
              }
            })
            .catch((e) => {
              if (e) console.log(e);
            });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    // 自动保存
    startAutoSaveInterval() {
      this.$nextTick(() => {
        this.autoSaveIntervalTimer = setInterval(() => {
          applicationFormService
            .getApplicationData(this.applicantId)
            .then((data) => {
              if (data.application_status === 1) {
                this.autoSave();
              } else {
                clearInterval(this.autoSaveIntervalTimer);
              }
            });
        }, 120000);
      });
    },

    autoSave() {
      let newData = extend({}, this.applicationData);
      newData = applicationFormService.formFilter(
        this.applicationConfig,
        newData,
      );
      this.applicationConfig.forEach((group) => {
        if (!applicationFormService.groupValid(group, newData)) {
          this.updateGroupStatus(
            group.name,
            applicantConstants.APPLICATION_GROUP_STATUS.invalid,
          );
          newData[group.name] = false;
        }
      });
      this.saveGroup(
        this.applicationConfig[this.currentActiveGroupIndex].name,
        true,
        newData,
      );
    },

    // 字段值变化
    fieldValueChanged(changeObject) {
      // 必需要重新赋值才会响应(这里不需要递归继承，因为Popup是整体替换的)
      this.applicationData = extend({}, this.applicationData, {
        [changeObject.name]: changeObject.value,
      });
    },

    // 改变组状态
    updateGroupStatus(groupName, status) {
      this.groupStatus = extend(true, {}, this.groupStatus, {
        [groupName]: status,
      });
      this.$emit('updatedApplicationGroupStatus', this.groupStatus);
      this.applicationData = extend({}, this.applicationData, {
        [groupName]: status,
      });
    },

    // 获取大使馆配置对象
    getEmbassyDistrict() {
      // --------------获取大使馆id代码块
      // 从json文件中获取大使馆配置
      // 声明含有大使馆地址属性的信息组
      let embassyDistrictGroup = {};
      // 声明含有大使馆id属性的对象
      const embassy_district = {};
      this.applicationConfig.forEach((item) => {
        if (_.find(item.fields, o => o.backEndSaveFieldKey)) {
          embassyDistrictGroup = item;
        }
      });
      const embassyDistrictCongig = _.find(
        embassyDistrictGroup.fields,
        o => o.backEndSaveFieldKey,
      );

      // 如果大使馆配置存在，将配置中的id传给后台
      if (embassyDistrictCongig) {
        // 声明省份数组
        let values = [];
        // 如果请求中的json文件中含有省份数组则直接获取
        if (embassyDistrictCongig.values.length) {
          values = embassyDistrictCongig.values;
        }
        // 获取省份数组中和当前选中省份value一致的选项
        const targetValueItem = _.find(
          values,
          valueItem =>
            valueItem.value === this.applicationData[embassyDistrictCongig.name],
        );
        if (targetValueItem) {
          // 以大使馆配置的backEndSaveFieldKey属性的value作为key，当前选中省份的backEndValue作为value
          embassy_district[embassyDistrictCongig.backEndSaveFieldKey] =
            targetValueItem.backEndValue;
        }
      }
      return embassy_district;
      // --------------获取大使馆id代码块
    },

    // 组保存
    /**
     * @param {Boolean} autoSave 是否自动保存
     * @param {Object} saveData 自动保存的数据，为了过滤不合规数据后不影响表格展示，自动保存的数据是一份副本
     */
    saveGroup(config, autoSave, saveData) {
      if (!autoSave) {
        this.applicationData = applicationFormService.setAllNeedUpperCaseField(
          this.applicationData,
          this.applicationConfig,
        );
      } else {
        saveData = applicationFormService.setAllNeedUpperCaseField(
          saveData,
          this.applicationConfig,
        );
      }

      this.submitting = !autoSave; // 如果是自动保存,就直接不禁用按钮
      applicationFormService
        .applicationSave(
          this.applicantId,
          autoSave ? saveData : this.applicationData,
          config.name,
          this.getEmbassyDistrict(),
        )
        .then((data) => {
          // 保存了要更新申请表状态
          this.applicantApplicationOriginData.application_status =
            data.application_status;

          // 最后一步保存完表单之后，要继续提交表单
          if (config.thenSubmitForm) {
            this.$nextTick(() => {
              // 这里之所以只处理catch，是因为applicationSubmit在验证阶段会返回一些reject的promise，如果已经过了验证阶段
              // 提交之后的逻辑在applicationSubmit方法里已经处理
              this.applicationSubmit().catch((errorMsg) => {
                utils.msg.error(errorMsg);
                this.submitting = false;
              });
            });
          } else {
            // 成功了往下走tab
            if (
              !autoSave &&
              this.currentActiveGroupIndex !== this.filterApplicationConfig.length - 1
            ) {
              this.currentActiveGroupIndex += 1;

              // 回到顶部
              scrollTo(0, 0);
            }
            this.submitting = false;
            !autoSave && utils.msg.success('保存成功');
            // utils.msg.success(autoSave ? '自动保存成功' : '保存成功');
          }
        })
        .catch((e) => {
          if (e) console.log(e);
          this.submitting = false;
        });
    },

    // 申请表提交(因为场景很多,所以这个方法提供给父组件调用)
    applicationSubmit() {
      this.formSubmitted = true;
      this.applicationData = applicationFormService.setAllNeedUpperCaseField(
        this.applicationData,
        this.applicationConfig,
      );

      // 申请表不合法
      if (
        !applicationFormService.formValid(
          this.applicationConfig,
          this.applicationData,
        )
      ) {
        return Promise.reject('内容输入不正确，请检查标红的部分');
      }

      // 还未确认(但是已经保存过，就不需要再确认了)
      if (
        !this.applicationData.ensured &&
        this.needEnsure &&
        !this.formEnsured
      ) {
        return Promise.reject('请勾选确认资料正确无误');
      }

      this.submitting = true;
      const applicantionSubmitData = applicationFormService.createApplicationSubmitData(
        this.applicationData,
        this.groupStatus,
      );
      return applicationFormService
        .applicationSubmit(
          this.applicantId,
          applicantionSubmitData,
          this.getEmbassyDistrict(),
        )
        .then((data) => {
          // 提交了也要更新申请表状态
          this.applicantApplicationOriginData.application_status =
            data.application_status;

          // 这两行的目的是让下面判断申请表是否有变化更准确
          this.applicantApplicationOriginData.content = JSON.stringify(
            applicantionSubmitData,
          );
          this.applicationData = applicantionSubmitData;

          this.submitting = false;
          utils.msg.success('提交成功');

          // 预审不通过页面需要根据最新的申请表状态得到是否资料修改完成
          this.$emit(
            'formSubmittdSuccess',
            this.applicantApplicationOriginData.application_status,
          );

          // 调用这个函数来重新计算导航到顶部的距离，因为在预审不通过页面顶部预审不通过提示语消失之后，距离顶部的距离会发生变化
          const rejectElement = document.querySelector(
            '.material-memo',
            '.application-reject',
          );
          if (rejectElement) {
            this.$refs.applicationNav.setNavToTop(rejectElement.clientHeight);
          }
        })
        .catch((e) => {
          if (e) console.log(e);
          this.submitting = false;
        });
    },

    // 判断申请表是否变化(可供父层调用)
    isApplicationDataChanged() {
      if (this.applicantApplicationOriginData.content) {
        return !_.isEqual(
          this.applicationData,
          JSON.parse(this.applicantApplicationOriginData.content),
        );
      }
      return true;
    },
  },
  watch: {
    backendApplicationUrl(newVal) {
      if (newVal) {
        this.getApplicationConfig(newVal);
      }
    },
  },
  computed: {
    filterApplicationConfig() {
      return this.applicationConfig.filter(group => this.showField(group, this.applicationData));
    },
    hideNavBox() {
      return this.applicationConfig && this.applicationConfig.length === 1 && this.applicationConfig[0].hidePeerLeftNav;
    },
  },
  mounted() {
    // 随便取一个属性判断一下是否加载成功
    if (
      typeof this.applicantApplicationOriginData.application_status ===
      'undefined'
    ) {
      this.loadingInstance = Loading.service({
        target: '#application-form',
        text: '数据加载中',
      });
    }
  },
  created() {
    this.getPcd();
    if (this.backendApplicationUrl) {
      this.getApplicationConfig(this.backendApplicationUrl);
    }
  },
  destroyed() {
    clearInterval(this.autoSaveIntervalTimer);
    this.autoSaveIntervalTimer = null;
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
section#application-form {
  display: flex;
  background-color: white;
  min-height: 600px;
  &.with-box-shadow {
    box-shadow: 0px -4px 0px 0px #fbfbfb,
      // 使用这个将原本断开的header连起来
      1px0px4px 0px rgba(0, 0, 0, 0.1);
  }
  div.nav-box {
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: @bg-light;
  }
  div.group-content {
    flex: 1;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-form.vue